let namespace: string;

export const DEFAULT_NAMESPACE = '/ajax-trade-in';

export function setNamespace(value?: string) {
  namespace = value || DEFAULT_NAMESPACE;
}

export function url(path: string) {
  if (!namespace) {
    throw new Error('API namespace has not been set.');
  }

  return `${namespace}/${path}`;
}
